import React from "react";
import { Link } from "react-scroll";
import marufLogo from "../../image/maruf2.jpg";
import "./Home.css";

const Home = () => {
  return (
    <div
      id="home"
      style={{ height: "600px" }}
      className="d-flex justify-content-center align-items-center"
    >
      <div className="text-center">
        <img className="marufLogo-style" src={marufLogo} alt="" />
        <h2 className="mt-4 text-link-color">Hey! I'am Mohammad Maruf.</h2>
        <p className="text-link-color">
          I'm a Passionate{" "}
          <span style={{ color: "#45d1cc" }}>Full Stack Developer</span>
        </p>
        <div className="mt-4">
          <Link
            className="btn btn-info m-2 btn-style"
            to="contact"
            smooth={true}
            duration={50}
          >
            Hire Me
          </Link>
          <a
            target="_blank"
            href="https://drive.google.com/file/d/1tQGqCVBJbm8yaSRp4uJPKgdgaL83EXVF/view?usp=sharing"
            className="btn btn-info btn-style"
            rel="noreferrer"
          >
            Download CV
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;
